//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from "../../src/common/helpers/HttpHelper";
import environments from "../../src/common/environments/environment";
const http = new httpHelper();

export const CandidateSearchActions = {
  GetCandidateSearch: getCandidateSearch,
  UpdateLeaveNoteMessage: updateLeaveNoteMessage,
  GetLeaveNoteMessage: getLeaveNoteMessage,
  GetCandidatePersonalInformation: getCandidatePersonalInformation,
  GetCandidateProgramDetail: getCandidateProgramDetail,
  GetCandidatePlatformDetail: getCandidatePlatformDetail,
  GetCandidateContactDetails: getCandidateContactDetails,
  GetCandidateCoachSections: getCandidateCoachSections,
  GetCandidateUpComingMeetings: getCandidateUpComingMeetings,
  GetCandidateSearchJSON: getCandidateSearchJSON,
  GetSearchResultsJSON: getSearchResultsJSON,
  GetCandidateProfileJSON: getCandidateProfileJSON,
  GetCandidateActivityJSON: getCandidateActivityJSON,
  GetCandidateActivitySnapshotJSON: getCandidateActivitySnapshotJSON,
  GetJobLanded: getJobLanded,
  GetLanguagePrefrencesDropdown: GetLanguagePrefrencesDropdown,
  CandidateLogin: CandidateLogin,
  GetAssessmentCount: GetAssessmentCount,
  GetAppiledJobsCount: GetAppiledJobsCount,
  GetEventCount: GetEventCount,
  GetCandidateActivityes: getCandidateActivitys,
  GetCreateActivityes: getCreateActivitys,
  TrackAction: trackAction,
  SaveCandidateProfile: saveCandidateProfile,
  SaveCandidateContactPreference: saveCandidateContactPreference,
  GetTimeZone: getTimeZone,
  GetTpsBlackListStatus: getTpsBlackListStatus,
};

function getCandidateSearch(searchString) {
  let candidateSearch = environments.CANDIDATE_SEARCH + "?" + searchString;
  return http.canDetailsGet(candidateSearch);
}

function updateLeaveNoteMessage(candidateID, payload) {
  return http.candidatePost(
    environments.SEND_LEAVE_NOTE + "?CandidateId=" + candidateID,
    payload
  );
}

function getLeaveNoteMessage(candidateID) {
  return http.canDetailsGet(
    environments.GET_LEAVE_NOTE_MESSAGE + "?CandidateId=" + candidateID
  );
}
function getCandidatePersonalInformation(id) {
  return http.canDetailsGet(
    environments.PERSONAL_INFORMATION.replace("{id}", id)
  );
}

function getCandidateProgramDetail(id, cid) {
  return http.canDetailsGet(
    environments.PROGRAM_DETAIL.replace("{referenceId}", id).replace(
      "{cid}",
      cid
    )
  );
}
function getCandidateActivitys(candidateID) {
  return http.CandidateActivityGet(
    environments.CANDIDATE_ACTIVYTY + "?CandidateId=" + candidateID
  );
}
function getCreateActivitys() {
  return http.CandidateCreateActivity(
    environments.CANDIDATE_ACTIVYTY_CREATE_ACTIVITY
  );
}
function getCandidatePlatformDetail(id, cid) {
  return http.canDetailsGet(
    environments.PLATFORM_DETAIL.replace("{referenceId}", id).replace(
      "{cid}",
      cid
    )
  );
}

function getCandidateContactDetails(id) {
  return http.canDetailsGet(environments.CONTACT_DETAILS.replace("{id}", id));
}

function getCandidateCoachSections(candidateID) {
  return http.canDetailsGet(
    environments.COACH_SECTIONS + "?CandidateId=" + candidateID
  );
}

function trackAction(payload) {
  return http.adminPost(environments.TRACK_ADMIN_ACTIONS, payload);
}

function getCandidateSearchJSON() {
  return http.jsonGet(
    environments.CONTAINER_NAME + environments.CANDIDATE_SEARCH_JSON
  );
}

function getSearchResultsJSON() {
  return http.jsonGet(
    environments.CONTAINER_NAME + environments.SEARCH_RESULTS_JSON
  );
}

function getCandidateProfileJSON() {
  return http.jsonGet(
    environments.CONTAINER_NAME + environments.CANDIDATE_PROFILE_JSON
  );
}

function getCandidateActivityJSON() {
  return http.jsonGet(
    environments.CONTAINER_NAME + environments.CANDIDATE_ACTIVITY_JSON
  );
}

function getCandidateActivitySnapshotJSON() {
  return http.jsonGet(
    environments.CONTAINER_NAME + environments.CANDIDATE_ACTIVITYSNAPSHOT_JSON
  );
}
function getCandidateUpComingMeetings(email, data) {
  return http.coachGet(
    environments.UPCOMING_MEETINGS + "?CandidateEmailAddress=" + email,
    data
  );
}
function getJobLanded(id) {
  return http.jobLandedGet(environments.JOB_LANDED.replace("{id}", id));
}
function GetLanguagePrefrencesDropdown(payload) {
  return http.adminPost(environments.GET_MYPROFILE_LABELS, payload);
}

function CandidateLogin(cid) {
  return http.candidateLogin(
    environments.CANDIDATE_LOGIN.replace("{cid}", cid)
  );
}
function GetAssessmentCount(cid) {
  return http.AssessmentCountGet(
    environments.ASSESSMENT_COUNT.replace("{cid}", cid)
  );
}
function GetAppiledJobsCount(cid) {
  return http.AppiledJobsCountGet(
    environments.APPLIED_JOBS_COUNT.replace("{cid}", cid)
  );
}
function GetEventCount(cid) {
  return http.EventCountGet(environments.EVENT_COUNT.replace("{cid}", cid));
}
function saveCandidateProfile(id, payload) {
  let candidateId = environments.PERSONAL_INFORMATION.replace("{id}", id);
  return http.canDetailsPut(candidateId, payload);
}
function saveCandidateContactPreference(id, payload) {
  let candidateId = environments.CONTACT_DETAILS.replace("{id}", id);
  return http.canDetailsPost(candidateId, payload);
}
function getTimeZone(language) {
  return http.getTimezoneData(
    environments.TIMEZONE.replace("{lang}", language)
  );
}
function getTpsBlackListStatus(candidateId) {
  return http.canDetailsGet(
    environments.TPS_CANDIDATE_BLAKLIST_STATUS.replace("{id}", candidateId)
  );
}
